/**
 * 会员管理
 */
import { VIP_MANAGEMENT } from '../types';

export default {
    name: `${VIP_MANAGEMENT}`,
    path: '/VipManagement',
    component: () => import(/* webpackChunkName: 'VipManagement' */ '@/views/vipManagement/'),
    redirect: { name: `${VIP_MANAGEMENT}Index` },
    meta: {
        title: '会员管理',
        // 页签缓存的滚动条位置
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${VIP_MANAGEMENT}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'VipManagement' */ '@/views/vipManagement/home/Home.vue'),
        },
    ],
};
